<style lang="scss">

</style>

<template>
  <!-- eslint-disable -->
  <div class="post-search-page mb-4">
    <section class="mb-2">
      <print-on-site-btn @pdf-generated="getPost()"></print-on-site-btn>
    </section>

    <section class="my-2">
      <h4>Filters</h4>

      <div class="row">
        <section class="col-3">
          <label>{{'prisoner' | term(true)}} Number</label>
          <b-form-input
            @keyup.enter="searchPost()"
            @input="updateFilter('prisonerNumber', $event.toUpperCase())"
            :value="filters.prisonerNumber"
            class="mb-1" :placeholder="'Enter ' + $options.filters.term('prisoner') + ' number'"
          />
        </section>

        <section class="col-3">
          <label>External Contact Email <small>( full email needed )</small></label>
          <b-form-input
            @keyup.enter="searchPost()"
            @input="updateFilter('visitorEmail', $event)"
            :value="filters.visitorEmail"
            type="email"
            class="mb-1" placeholder="Enter external contact email"
          />
        </section>

        <section class="col align-items-center d-flex" style="margin-top: 7px">
          <div class="ui-spacer"></div>
          <b-button :class="{'disabled' : !canSearch()}" class="btn-success ml-1" @click="searchPost()">Search</b-button>
        </section>
      </div>
    </section>

    <b-card no-body class="mb-0">
      <section>
        <b-table
          class="data-table"
          hover
          :items="post"
          :fields="headers"
          :current-page="currentPage"
          :per-page="0"
        >
          <template #cell(visitorName)="data">
            {{data.item.visitor.firstname}} {{data.item.visitor.lastname}}
          </template>
          <template #cell(updated_at)="data">
            {{data.item.updated_at | formatDateTime}}
          </template>
          <template #cell(clinician_assigned)="data">
            {{data.item.clinician_assigned ? data.item.clinician_assigned.name : '-'}}
          </template>

          <template #cell(actions)="data">
            <router-link v-if="data.item.post_type === 'Physical'" :to="{ name: 'post-view', params: { id: data.item._id } }" class="font-weight-bold d-block text-nowrap">
              View
            </router-link>
          </template>
        </b-table>
        <b-row class="p-1">
          <b-col md="6" class="m-1" v-if="totalRows > filters.limit">
            <b-pagination :total-rows="totalRows" :per-page="filters.limit" v-model="currentPage" class="my-0"/>
          </b-col>
          <p v-if="totalRows === 0" class="col-6 ml-2 my-1">No post to show</p>
        </b-row>
      </section>
    </b-card>
  </div>
  <!-- eslint-enable -->
</template>

<script>
import { mapState } from 'vuex';
import HelperService from '../../services/HelperService';
import PostService from '../../services/PostService';
import PrintOnSiteBtn from '../../components/printQueue/PrintOnSiteBtn.vue';

export default {
  name: 'PostSearchLimited',
  components: {
    PrintOnSiteBtn,
  },
  data() {
    return {
      helperService: new HelperService(),
      loading: true,
      headers: [
        { label: `${this.$options.filters.term('prisoner')} Number`, key: 'prisoner_number' },
        { label: 'Visitor', key: 'visitorName' },
        { label: 'Staff Assigned', key: 'clinician_assigned' },
        { label: 'Updated', key: 'updated_at' },
        { label: '', key: 'actions' },
      ],
      post: [],
      currentPage: 1,
      totalRows: 10,
    };
  },
  computed: {
    ...mapState({
      filters: state => state.postCard.filters,
    }),
  },
  watch: {
    currentPage() {
      this.getPost();
    },
  },
  mounted() {
    // preset filters
    this.updateFilter('status', 'Approved');
    this.updateFilter('delivered', true);
    this.updateFilter('dispatched', null);
    this.updateFilter('sentForPrinting', true);
    // reset dates
    this.updateFilter('before', '');
    this.updateFilter('after', '');
  },
  methods: {
    searchPost() {
      this.currentPage = 1;
      this.getPost();
    },
    canSearch() {
      return this.filters.visitorEmail || this.filters.prisonerNumber;
    },
    getPost() {
      if (this.canSearch()) {
        this.updateFilter('skip', (this.currentPage - 1) * this.filters.limit);

        PostService.getAll(this.filters).then(res => {
          this.loading = false;
          this.post = res.data.data;
          this.totalRows = res.data.count;
        }).catch(err => {
          console.log('Error getting post ', err);
          this.$toast.error('Could not get post, please refresh and try again', {
            toastClassName: ['toast-std', 'warning-toast'],
          });
        });
      }
    },
    updateFilter(filterName, e, refresh) {
      this.$store.commit('postCard/SET_FILTER_ITEM', { name: filterName, value: e });

      if (refresh) {
        this.searchPost();
      }
    },
  },
};
</script>
